import firebase from 'firebase';

const config = {
	apiKey: "AIzaSyB11uY4FytVsoAM6AM5YLsWI-JzJxKlJYc",
	authDomain: "roadtripplanner-bf7a1.firebaseapp.com",
	databaseURL: "https://roadtripplanner-bf7a1.firebaseio.com",
	projectId: "roadtripplanner-bf7a1",
	storageBucket: "roadtripplanner-bf7a1.appspot.com",
	messagingSenderId: "946276701198"
};

const handleErrors = (err) => {
	if(err.code === "PERMISSION_DENIED") {
		alert("Either you are not logged in or you don't have access to this roadtrip. Ask the owner for access.");
	} else {
		alert("Unknown error: " + err);
	}
};

const fire = firebase.initializeApp(config);

export default fire;
export {
	handleErrors
};


// WEBPACK FOOTER //
// ./src/util/fire.js